// import React, { useEffect, useState, useMemo } from 'react';
// import {
//   Box, Button, Paper, Typography, Grid, MenuItem,
//   TableContainer, Table, TableHead, TableBody,
//   IconButton
// } from '@mui/material';
// import {
//   ActionMsg, Breadcrumb, Cancel, CTSinput, HandleCloseSnackbar,
//   StyledTableCell, StyledTableRow
// } from '../../reusableComponent/Reusables';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useForm } from 'react-hook-form';
// import AddIcon from '@mui/icons-material/Add';
// import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
// import SaveIcon from '@mui/icons-material/Save';
// import styles from '../../../styles.module.css';
// import dayjs from 'dayjs';
// import useUnsavedChanges from '../../reusableComponent/UnsavedChanges';
// import withSaveConfirmation from '../../reusableComponent/saveConfirmation';

// import pickupService from '../../../services/pickup.Service';
// import inwardService from '../../../services/inward.Service';
// import driverMasterService from '../../../services/masters/driverMaster.Service';
// import cylinderMasterService from '../../../services/masters/cylinderMaster.Service';
// import customerMasterService from '../../../services/masters/customerMaster.Service';
// import vehicleMasterService from '../../../services/masters/vehicleMaster.Service';
// import depotMasterService from '../../../services/masters/depotMaster.Service';
// import plantMasterService from '../../../services/masters/plantMaster.Service';
// import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
// import transferToPlantService from '../../../services/transferToPlant.Service';
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";



// const Add_transfer_plant_entry = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { handleSubmit } = useForm();
//   const location = useLocation();
//   const editData = location.state || null;

//   const login_details = sessionStorage.getItem('loginUser');
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const depot_id = userInfo.depot_id;
//   const depot_name = userInfo.depot_name;
//   const unit_id = userInfo.depot_id || userInfo.plant_id;
//   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
//   const user_id = userInfo.user_id;
//   const assigned_plant_id = userInfo.assigned_plant_id;
//   const assigned_plant_name = userInfo.assigned_plant_name;

//   const [successMessage, setSuccessMessage] = useState('');
//   const [warningMessage, setWarningMessage] = useState('');
//   const [inward, setInward] = useState([]);
//   const [depots, setDepots] = useState([]);
//   const [plants, setPlants] = useState([]);
//   const [fromLocationName, setFromLocationName] = useState(depot_name || '');

// const initialData = useMemo(
//   () => ({
//     entry_id: editData?.entry_id || null,
//     entry_no: editData?.entry_no || '',
//     entry_date: editData?.entry_date
//       ? dayjs(editData.entry_date).format("YYYY-MM-DD")
//       : dayjs().format("YYYY-MM-DD"),
//     driver_id: editData?.driver_id || '',
//     from_customer_id: editData?.from_customer_id || '',
//     from_depot_id: depot_id || '',
//     to_plant_id: editData?.to_plant_id || assigned_plant_id || '',
//     to_location: editData?.to_location || assigned_plant_name || '',
//     inward_id: editData?.inward_id || '',
//     inward_no: editData?.inward_no || '',
//     fin_year: editData
//       ? editData.fin_year
//       : dayjs().month() >= 3
//         ? `${dayjs().year()}-${dayjs().year() + 1}`
//         : `${dayjs().year() - 1}-${dayjs().year()}`,
//   }),
//   [editData, depot_id, assigned_plant_id, assigned_plant_name]
// );

//   const [data, setData] = useState(initialData);

//   const initialTransferDetails = useMemo(
//     () =>
//       editData?.table_details
//         ? JSON.parse(editData.table_details).map((item) => ({
//           srno: item.srno || '',
//           cylinder_no: item.cylinder_no || item.cyl_no || '',
//           cyl_id: item.cyl_id || '',
//           prod_code: item.prod_code || '',
//           prod_id: item.prod_id || '',
//           status: item.status || '',
//           owner: item.owner || '',
//           note: item.note || item.reason || 'INSPDUE',
//         }))
//         : [{ srno: '1', cylinder_no: '', cyl_id: '', prod_code: '', prod_id: '', status: '', owner: '', note: 'INSPDUE' }],
//     [editData]
//   );

//   const [transferDetails, setTransferDetails] = useState(initialTransferDetails);

//   const isFormDirty = useMemo(
//     () => JSON.stringify(data) !== JSON.stringify(initialData) || JSON.stringify(transferDetails) !== JSON.stringify(initialTransferDetails),
//     [data, transferDetails, initialData, initialTransferDetails]
//   );

//   const { confirmNavigation } = useUnsavedChanges(isFormDirty);

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const [
//           inwardData,
//           depotData,
//           plantData,
//           InwardNo,
//         ] = await Promise.all([
//           inwardService.getCylinderInwardList({ page: 0, size: 999, searchKey: '' }),
//           depotMasterService.getDepotList({ page: 0, size: 999, searchKey: '' }),
//           plantMasterService.getPlantList({ page: 0, size: 999, searchKey: '' }),
//           transferToPlantService.getInwardNo(depot_id),
//         ]);

//         setInward(InwardNo);
//         setPlants(plantData);
//         setFromLocationName(depot_name || '');

//         setData((prev) => ({ ...prev, from_depot_id: depot_id, from_location: depot_name }));
//       } catch (error) {
//         setWarningMessage('Error fetching depot or plant data.');
//         console.error(error);
//       }
//     }
//     fetchData();
//   }, [depot_id, depot_name]);

// const handleChange = (e) => {
//   const { name, value } = e.target;
//   const updatedData = {
//     ...data,
//     [name]: value,
//   };

//   if (name === 'inward_id') {
//     const selectedInward = inward.find((item) => item.inward_id === value);

//     if (selectedInward) {
//       let combinedDetails = [];

//       if (selectedInward.table_details) {
//         try {
//           const details = JSON.parse(selectedInward.table_details);
//           combinedDetails = combinedDetails.concat(details);
//         } catch (error) {
//           console.error('Failed to parse table_details', error);
//           setWarningMessage('Invalid table details in selected inward entry.');
//         }
//       }

//       const uniqueDetails = combinedDetails.filter(
//         (detail, index, self) =>
//           index === self.findIndex((d) => d.srno === detail.srno && d.cyl_no === detail.cyl_no)
//       );

//       const parsedTableDetails = uniqueDetails.map((item, index) => ({
//         srno: (index + 1).toString(),
//         cylinder_no: item.cylinder_no || item.cyl_no || '',
//         cyl_id: item.cyl_id || '',
//         prod_code: item.prod_code || '',
//         prod_id: item.prod_id || '',
//         owner: item.owner || '',
//         status: item.status || '',
//         note: item.note || item.reason || 'INSPDUE',
//       }));

//       const selectedPlant = plants.find((p) => p.plant_id === selectedInward.to_plant_id);
//       const toLocationName = selectedPlant?.plant_name || selectedInward.to_location || '';

//       setData((prev) => ({
//         ...prev,
//         inward_id: selectedInward.inward_id,
//         inward_no: selectedInward.entry_no || '',
//         entry_no: editData ? prev.entry_no : '',
//         entry_date: selectedInward?.entry_date
//           ? dayjs(selectedInward.entry_date).format("YYYY-MM-DD")
//           : dayjs().format("YYYY-MM-DD"),
//         to_plant_id: assigned_plant_id || '',
//         to_location: assigned_plant_name || '',
//         driver_id: selectedInward.driver_id || '',
//         from_customer_id: selectedInward.from_customer_id || '',
//         from_depot_id: selectedInward.from_depot_id || userInfo.depot_id || '',
//         from_location: selectedInward.from_depot_name || fromLocationName,
//         fin_year: selectedInward.fin_year || (
//           dayjs().month() >= 3
//             ? `${dayjs().year()}-${dayjs().year() + 1}`
//             : `${dayjs().year() - 1}-${dayjs().year()}`
//         ),
//       }));

//       setTransferDetails(
//         parsedTableDetails.length > 0
//           ? parsedTableDetails
//           : [{ srno: '', cylinder_no: '', cyl_id: '', prod_code: '', prod_id: '', status: '', owner: '', note: 'INSPDUE' }]
//       );
//     } else {
//       setData((prev) => ({
//         ...prev,
//         inward_id: value,
//         inward_no: '',
//         entry_no: editData ? prev.entry_no : '',
//         entry_date: editData?.entry_date
//           ? dayjs(editData.entry_date).format("YYYY-MM-DD")
//           : dayjs().format("YYYY-MM-DD"),
//         to_plant_id: assigned_plant_id || '',
//         to_location: assigned_plant_name || '',
//         driver_id: '',
//         from_customer_id: '',
//         from_depot_id: userInfo.depot_id || '',
//         from_location: fromLocationName,
//         fin_year:
//           dayjs().month() >= 3
//             ? `${dayjs().year()}-${dayjs().year() + 1}`
//             : `${dayjs().year() - 1}-${dayjs().year()}`,
//       }));
//       setTransferDetails([
//         { srno: '', cylinder_no: '', cyl_id: '', prod_code: '', prod_id: '', status: '', owner: '', note: 'INSPDUE' },
//       ]);
//     }
//   } else if (name === 'entry_date') {
//     const selectedDate = dayjs(value);
//     if (selectedDate.isValid()) {
//       const month = selectedDate.month();
//       const year = selectedDate.year();
//       const financialYear = month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
//       setData((prev) => ({ ...prev, entry_date: selectedDate.format("YYYY-MM-DD"), fin_year: financialYear }));
//     } else {
//       setData((prev) => ({ ...prev, entry_date: "" }));
//       setWarningMessage("Invalid date selected.");
//     }
//   } else {
//     setData((prev) => ({ ...prev, [name]: value }));
//   }
// };

//   const handleChangeInput = async (e, index) => {
//     const { name, value } = e.target;
//     const updated = [...transferDetails];
//     updated[index][name] = value;

//     if (name === 'cylinder_no' && value) {
//       try {
//         const cylList = await cylinderMasterService.getCylinderList({
//           page: 0,
//           size: 1,
//           searchKey: value,
//         });
//         if (Array.isArray(cylList) && cylList.length > 0) {
//           updated[index]['cyl_id'] = cylList[0].cyl_id || '';
//           updated[index]['status'] = cylList[0].status || cylList[0].state || '';
//         } else {
//           updated[index]['cyl_id'] = '';
//           updated[index]['status'] = '';
//         }
//       } catch (err) {
//         updated[index]['cyl_id'] = '';
//         updated[index]['status'] = '';
//       }
//     }
//     setTransferDetails(updated);
//   };

//   const handleAddSPQuotationFields = () => {
//     setTransferDetails((prev) => [
//       ...prev,
//       { srno: '', cylinder_no: '', cyl_id: '', prod_code: '', prod_id: '', status: '', owner: '', note: 'INSPDUE' },
//     ]);
//   };

//   const handleRemovepickup = (index) => {
//     setTransferDetails((prev) => prev.filter((_, i) => i !== index));
//   };

//   const onSubmit = async (formData) => {
//     if (!formData.from_depot_id && !userInfo.plant_id) {
//       setWarningMessage('Cannot submit: No valid depot or plant assigned.');
//       return;
//     }
//     if (!assigned_plant_id) {
//       setWarningMessage('Cannot submit: No assigned plant.');
//       return;
//     }

//     const inwardData = {
//       ...formData,
//       to_plant_id: assigned_plant_id,
//       to_location: assigned_plant_name,
//       modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
//       modified_by: editData ? userInfo.user_id : null,
//       created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
//       created_by: editData ? editData.created_by : userInfo.user_id,
//       table_details: JSON.stringify(transferDetails),
//       changedUpdatedValue: 'edit',
//       short_code: short_code,
//       unit_id: unit_id,
//     };

//     if (editData) {
//       await transferToPlantService.editDeletetransfartoplant(inwardData);
//     } else {
//       await transferToPlantService.addtransfartoplant(inwardData);
//     }
//   };

//   const handleSubmitWithConfirmation = withSaveConfirmation(onSubmit);

//   const handleCancel = () => {
//     confirmNavigation(-1);
//   };

//   return (
//      <LocalizationProvider dateAdapter={AdapterDayjs}>
//     <Box className={styles.cts_page}>
//       <Box className={styles.body}>
//         <Breadcrumb routeSegments={[{ name: 'Transfer to plant entry' }]} />

//         <Box sx={{ display: 'flex' }}>
//           <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
//             <Grid item md={7}>
//               <Typography className={styles.header_txt}>TRANSFER TO PLANT ENTRY
//               </Typography>
//             </Grid>
//           </Grid>
//         </Box>

//         <form
//           onSubmit={handleSubmit(() =>
//             handleSubmitWithConfirmation(data, setSuccessMessage, setWarningMessage, navigate, editData)
//           )}
//         >
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
//             {editData === null && (
//               <Typography className={styles.lastEntry_Txt}>
//                 Last Entry No : {inward?.[0]?.lastScheduleEntryNo || 0}
//               </Typography>
//             )}
//           </Box>

//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6}>
//               <Grid container spacing={1}>
//                 <Grid item xs={12} sm={6}>
//                   <Typography className={styles.label_Txt}>Inward No</Typography>
//                   <CTSinput
//                     select
//                     fullWidth
//                     size="small"
//                     name="inward_id"
//                     value={data.inward_id || ''}
//                     onChange={handleChange}
//                     InputProps={{ className: styles.CTSinput_Box }}
//                   >
//                     {editData && !editData.inward_id && (
//                       <MenuItem value="" disabled selected className={styles.cts_lable}>
//                         {editData.entry_no ? `Original: ${editData.entry_no}` : 'No Inward Entry'}
//                       </MenuItem>
//                     )}
//                     {inward.length > 0 ? (
//                       inward.map((d) => (
//                         <MenuItem key={d.inward_no} value={d.inward_id} className={styles.cts_lable}>
//                           {d.entry_no}
//                         </MenuItem>
//                       ))
//                     ) : (
//                       <MenuItem value="" disabled>
//                         No inward entries available
//                       </MenuItem>
//                     )}
//                   </CTSinput>
//                 </Grid>
                

//                 <Grid item xs={12} sm={6}>
//                   <Typography className={styles.label_Txt}>Entry No</Typography>
//                   <CTSinput
//                     size="small"
//                     fullWidth
//                     name="entry_no"
//                     value={data.entry_no}
//                     onChange={handleChange}
//                     InputProps={{
//                       readOnly: true,
//                       className: styles.CTSinput_Box,
//                       style: { backgroundColor: '#f0f0f0' },
//                     }}
//                   />
//                 </Grid>

//                 {/* <Grid item xs={12} sm={6}>
//                   <Typography className={styles.label_Txt}>From Location</Typography>
//                   <CTSinput
//                     size="small"
//                     fullWidth
//                     name="from_location"
//                     value={fromLocationName}
//                     InputProps={{
//                       readOnly: true,
//                       className: styles.CTSinput_Box,
//                       style: { backgroundColor: '#f0f0f0' },
//                     }}
//                   />
//                 </Grid> */}
//               </Grid>
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <Grid container spacing={1}>
//                 <Grid item xs={12} sm={6}>
//                   <Typography className={styles.label_Txt}>Entry Date</Typography>
//                   <DatePicker
//   format="DD/MM/YYYY"
//   value={data.entry_date ? dayjs(data.joining_dt) : dayjs()} // Default to current date
//   onChange={(newValue) =>
//     handleChange({
//       target: {
//         name: "entry_date",
//         value: newValue ? newValue.format("YYYY-MM-DD") : "",
//       },
//     })
//   }
//   slotProps={{
//     textField: {
//       size: "small",
//       fullWidth: true,
//       required: true,
//       InputProps: {
//         className: styles.CTSinput_Box,
//         disableUnderline: true,
//       },
//     },
//   }}
// />
//                 </Grid>

//                 {/* <Grid item xs={12} sm={6}>
//                   <Typography className={styles.label_Txt}>Plant</Typography>
//                   <CTSinput
//                     size="small"
//                     fullWidth
//                     name="to_location"
//                     value={assigned_plant_name || ''}
//                     InputProps={{
//                       readOnly: true,
//                       className: styles.CTSinput_Box,
//                       style: { backgroundColor: '#f0f0f0' },
//                     }}
//                   />
//                 </Grid> */}
//               </Grid>
//             </Grid>

//             <Grid item xs={12}>
//               <Paper sx={{ width: '100%' }}>
//                 <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
//                   <Table stickyHeader size="small">
//                     <TableHead>
//                       <StyledTableRow>
//                         <StyledTableCell align="center"  className={styles.table_head}>Sr No</StyledTableCell>
//                         <StyledTableCell  className={styles.table_head}>Cylinder No</StyledTableCell>
//                         <StyledTableCell className={styles.table_head}>Owner</StyledTableCell>
//                         <StyledTableCell className={styles.table_head}>Status</StyledTableCell>
//                         <StyledTableCell className={styles.table_head}>Note</StyledTableCell>
//                         <StyledTableCell align="center" className={styles.table_head}>Action</StyledTableCell>
//                       </StyledTableRow>
//                     </TableHead>
//                     <TableBody sx={{ backgroundColor: '#fff' }}>
//                       {transferDetails.map((row, index) => (
//                         <StyledTableRow key={index}>
//                           <StyledTableCell align="center"  className={`${styles.list_table_body}`}>{row.srno}</StyledTableCell>
//                           <StyledTableCell  className={`${styles.list_table_body}`}>
//                             <CTSinput
//                               fullWidth
//                               size="small"
//                               name="cylinder_no"
//                               value={row.cylinder_no}
//                               onChange={(e) => handleChangeInput(e, index)}
//                               InputProps={{
//                                 className: styles.CTSinput_Box,
//                                 style: {
//                                   border: "none",

//                                 },
//                               }}
//                             />
//                           </StyledTableCell>
//                           <StyledTableCell className={`${styles.list_table_body}`}>
//                             <CTSinput
//                               fullWidth
//                               size="small"
//                               type="text"
//                               name="owner"
//                               value={row.owner || ''}
//                               onChange={(e) => handleChangeInput(e, index)}
//                               InputProps={{
//                                 className: styles.CTSinput_Box, style: {
//                                   border: "none",

//                                 },
//                               }}
//                             />
//                           </StyledTableCell>
//                           <StyledTableCell className={`${styles.list_table_body}`}>
//                             <CTSinput
//                               fullWidth
//                               size="small"
//                               name="status"
//                               value={row.status}
//                               onChange={(e) => handleChangeInput(e, index)}
//                               InputProps={{
//                                 className: styles.CTSinput_Box, tyle: {
//                                   border: "none",

//                                 },
//                               }}
//                             />
//                           </StyledTableCell>
//                           <StyledTableCell className={`${styles.list_table_body}`}>
//                             <CTSinput
//                               fullWidth
//                               size="small"
//                               name="note"
//                               value={row.note}
//                               onChange={(e) => handleChangeInput(e, index)}
//                               InputProps={{
//                                 className: styles.CTSinput_Box, tyle: {
//                                   border: "none",

//                                 },
//                               }}
//                             />
//                           </StyledTableCell>
//                           <StyledTableCell align="center" className={`${styles.list_table_body}`}>
//                             <IconButton size="small" onClick={handleAddSPQuotationFields}>
//                               <AddIcon
//                                 sx={{ fontSize: 16, color: '#1b52d1', border: '1px solid #1b52d1', borderRadius: '50%' }}
//                               />
//                             </IconButton>
//                             {index !== 0 && (
//                               <IconButton size="small" onClick={() => handleRemovepickup(index)}>
//                                 <DeleteForeverIcon sx={{ fontSize: 16, color: 'red' }} />
//                               </IconButton>
//                             )}
//                           </StyledTableCell>
//                         </StyledTableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Paper>
//             </Grid>

//             <Grid item xs={12} className={`${styles.grid_input}`}>
//               <Box className={`${styles.btn_container}`}>
//                 <Box>
//                   <Button id={`${styles.btn_save}`} type="submit">
//                     <SaveIcon className={`${styles.btn_cancel_txt}`} />
//                     <Typography className={`${styles.btn_cancel_txt}`}>{editData ? "Update" : "Save"}</Typography>
//                   </Button>
//                 </Box>
//                 <Box>
//                   <Cancel />
//                 </Box>
//               </Box>
//             </Grid>
//           </Grid>
//         </form>

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={(event, reason) => {
//             if (reason !== 'clickaway') {
//               setSuccessMessage('');
//             }
//           }}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//         />
//         <ReusableSnackbar
//           open={!!warningMessage}
//           onClose={(event, reason) => {
//             if (reason !== 'clickaway') {
//               setWarningMessage('');
//             }
//           }}
//           message={warningMessage}
//           autoHideDuration={4000}
//           vertical="top"
//           horizontal="right"
//           severity="warning"
//         />
//       </Box>
//     </Box>
//     </LocalizationProvider>
//   );
// };

// export default Add_transfer_plant_entry;

import React, { useEffect, useState, useMemo } from 'react';
import {
  Box, Button, Paper, Typography, Grid, MenuItem,
  TableContainer, Table, TableHead, TableBody,
  IconButton, TextField, Autocomplete
} from '@mui/material';
import {
  ActionMsg, Breadcrumb, Cancel, CTSinput, HandleCloseSnackbar,
  StyledTableCell, StyledTableRow
} from '../../reusableComponent/Reusables';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import dayjs from 'dayjs';
import useUnsavedChanges from '../../reusableComponent/UnsavedChanges';
import withSaveConfirmation from '../../reusableComponent/saveConfirmation';

import pickupService from '../../../services/pickup.Service';
import inwardService from '../../../services/inward.Service';
import driverMasterService from '../../../services/masters/driverMaster.Service';
import cylinderMasterService from '../../../services/masters/cylinderMaster.Service';
import customerMasterService from '../../../services/masters/customerMaster.Service';
import vehicleMasterService from '../../../services/masters/vehicleMaster.Service';
import depotMasterService from '../../../services/masters/depotMaster.Service';
import plantMasterService from '../../../services/masters/plantMaster.Service';
import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
import transferToPlantService from '../../../services/transferToPlant.Service';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// ── Styles (matching Empty Challan exactly) ───────────────────────────────────

const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Inter', Arial, sans-serif",
};

const breadcrumbSx = {
  fontSize: "12px",
  color: "#718096",
  mb: 2,
  display: "flex",
  alignItems: "center",
  gap: "6px",
};

const pageHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2.5,
};

const pageTitleSx = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#000000",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const backBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#2B6CB0",
  padding: "7px 14px",
  border: "1.5px solid #2B6CB0",
  borderRadius: "7px",
  background: "#fff",
  cursor: "pointer",
  textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};

const formCardSx = {
  background: "#fff",
  border: "1px solid #E2E8F0",
  overflow: "hidden",
  mb: 2,
};

const sectionHeaderSx = {
  background: "#1C3A5E",
  padding: "12px 22px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const sectionHeaderTitleSx = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff",
  letterSpacing: "0.3px",
};

const formBodySx = { padding: "20px 22px" };

const fieldLabelSx = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#2063b6",
  mb: "4px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa",
    height: "36px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
    "&.Mui-disabled": { background: "#F8FAFC" },
  },
  "& input": {
    color: "#1A202C",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
  "& .MuiInputLabel-root": { display: "none" },
};

const readonlyInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    background: "#F0F4F8",
  },
};

const menuItemSx = { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" };

const formFooterSx = {
  padding: "18px 24px",
  background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
};

const saveBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#4CAF50",
  color: "#fff",
  border: "none",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  fontFamily: "'Inter', Arial, sans-serif",
  "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
  transition: "all 0.15s ease",
};

const cancelBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#E53E3E",
  color: "#ffffff",
  border: "none",
  "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
  fontSize: "14px",
  fontWeight: 600,
  borderRadius: "8px",
  textTransform: "none",
};

// ─────────────────────────────────────────────────────────────────────────────

const Add_transfer_plant_entry = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { handleSubmit } = useForm();
  const location = useLocation();
  const editData = location.state || null;

  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const depot_id = userInfo.depot_id;
  const depot_name = userInfo.depot_name;
  const unit_id = userInfo.depot_id || userInfo.plant_id;
  const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
  const user_id = userInfo.user_id;
  const assigned_plant_id = userInfo.assigned_plant_id;
  const assigned_plant_name = userInfo.assigned_plant_name;

  const [successMessage, setSuccessMessage] = useState('');
  const [warningMessage, setWarningMessage] = useState('');
  const [inward, setInward] = useState([]);
  const [depots, setDepots] = useState([]);
  const [plants, setPlants] = useState([]);
  const [fromLocationName, setFromLocationName] = useState(depot_name || '');

  const initialData = useMemo(
    () => ({
      entry_id: editData?.entry_id || null,
      entry_no: editData?.entry_no || '',
      entry_date: editData?.entry_date
        ? dayjs(editData.entry_date).format("YYYY-MM-DD")
        : dayjs().format("YYYY-MM-DD"),
      driver_id: editData?.driver_id || '',
      from_customer_id: editData?.from_customer_id || '',
      from_depot_id: depot_id || '',
      to_plant_id: editData?.to_plant_id || assigned_plant_id || '',
      to_location: editData?.to_location || assigned_plant_name || '',
      inward_id: editData?.inward_id || '',
      inward_no: editData?.inward_no || '',
      fin_year: editData
        ? editData.fin_year
        : dayjs().month() >= 3
          ? `${dayjs().year()}-${dayjs().year() + 1}`
          : `${dayjs().year() - 1}-${dayjs().year()}`,
    }),
    [editData, depot_id, assigned_plant_id, assigned_plant_name]
  );

  const [data, setData] = useState(initialData);

  const initialTransferDetails = useMemo(
    () =>
      editData?.table_details
        ? JSON.parse(editData.table_details).map((item) => ({
          srno: item.srno || '',
          cylinder_no: item.cylinder_no || item.cyl_no || '',
          cyl_id: item.cyl_id || '',
          prod_code: item.prod_code || '',
          prod_id: item.prod_id || '',
          status: item.status || '',
          owner: item.owner || '',
          note: item.note || item.reason || 'INSPDUE',
        }))
        : [{ srno: '1', cylinder_no: '', cyl_id: '', prod_code: '', prod_id: '', status: '', owner: '', note: 'INSPDUE' }],
    [editData]
  );

  const [transferDetails, setTransferDetails] = useState(initialTransferDetails);

  const isFormDirty = useMemo(
    () => JSON.stringify(data) !== JSON.stringify(initialData) || JSON.stringify(transferDetails) !== JSON.stringify(initialTransferDetails),
    [data, transferDetails, initialData, initialTransferDetails]
  );

  const { confirmNavigation } = useUnsavedChanges(isFormDirty);

 useEffect(() => {
  async function fetchData() {
    try {
     const [inwardData, depotData, plantData, InwardNo] = await Promise.all([
  inwardService.getCylinderInwardList({ page: 0, size: 999, searchKey: '' }),
  depotMasterService.getDepotList({ page: 0, size: 999, searchKey: '' }),
  plantMasterService.getPlantList({ page: 0, size: 999, searchKey: '' }),
  transferToPlantService.getInwardNo(depot_id),
]);

// Naya inward entry sabse upar dikhane ke liye descending sort
const sortedInward = Array.isArray(InwardNo)
  ? [...InwardNo].sort((a, b) => {
      if (a.inward_id && b.inward_id) return b.inward_id - a.inward_id;
      return new Date(b.entry_date) - new Date(a.entry_date);
    })
  : [];

setInward(sortedInward);
      setPlants(plantData);
      setFromLocationName(depot_name || '');
      setData((prev) => ({ ...prev, from_depot_id: depot_id, from_location: depot_name }));

      // ✅ Entry No Generation
      if (!editData) {
        const transferList = await transferToPlantService.gettransfartoplant({
          page: 0, size: 5, searchKey: '',
        });

        console.log("transferList:", transferList);
        console.log("All entry_nos:", transferList?.map(d => d.entry_no));

        const yr = dayjs();
        const finYear = yr.month() >= 3
          ? `${String(yr.year()).slice(-2)}-${String(yr.year() + 1).slice(-2)}`
          : `${String(yr.year() - 1).slice(-2)}-${String(yr.year()).slice(-2)}`;

        // Same fin_year ki entries filter karo
        const sameYearEntries = transferList?.filter(d => d.entry_no?.includes(finYear)) ?? [];
        console.log("sameYearEntries:", sameYearEntries);

        const lastEntryNo = sameYearEntries?.[0]?.entry_no ?? "";
        console.log("lastEntryNo:", lastEntryNo);

        const parts = String(lastEntryNo).split("/");
        const lastSeq = parseInt(parts[parts.length - 1]) || 0;
        const nextSeq = lastSeq + 1;

      const formattedEntryNo = `TR/${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;
        console.log("Generated entry_no:", formattedEntryNo);

        setData(prev => ({
          ...prev,
          entry_no: formattedEntryNo,
          fin_year: finYear,
        }));
      }

    } catch (error) {
      setWarningMessage('Error fetching depot or plant data.');
      console.error(error);
    }
  }
  fetchData();
}, [depot_id, depot_name]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...data, [name]: value };

    if (name === 'inward_id') {
      const selectedInward = inward.find((item) => item.inward_id === value);
      if (selectedInward) {
        let combinedDetails = [];
        if (selectedInward.table_details) {
          try {
            const details = JSON.parse(selectedInward.table_details);
            combinedDetails = combinedDetails.concat(details);
          } catch (error) {
            setWarningMessage('Invalid table details in selected inward entry.');
          }
        }
        const uniqueDetails = combinedDetails.filter(
          (detail, index, self) =>
            index === self.findIndex((d) => d.srno === detail.srno && d.cyl_no === detail.cyl_no)
        );
        const parsedTableDetails = uniqueDetails.map((item, index) => ({
          srno: (index + 1).toString(),
          cylinder_no: item.cylinder_no || item.cyl_no || '',
          cyl_id: item.cyl_id || '',
          prod_code: item.prod_code || '',
          prod_id: item.prod_id || '',
          owner: item.owner || '',
          status: item.status || '',
          note: item.note || item.reason || 'INSPDUE',
        }));


        const eligibleDetails = parsedTableDetails.filter(
          (item) => String(item.prod_id) === '1'
        );
        const selectedPlant = plants.find((p) => p.plant_id === selectedInward.to_plant_id);
        const toLocationName = selectedPlant?.plant_name || selectedInward.to_location || '';
        setData((prev) => ({
          ...prev,
          inward_id: selectedInward.inward_id,
inward_no: selectedInward.entry_no || '',
          entry_date: selectedInward?.entry_date
            ? dayjs(selectedInward.entry_date).format("YYYY-MM-DD")
            : dayjs().format("YYYY-MM-DD"),
          to_plant_id: assigned_plant_id || '',
          to_location: assigned_plant_name || '',
          driver_id: selectedInward.driver_id || '',
          from_customer_id: selectedInward.from_customer_id || '',
          from_depot_id: selectedInward.from_depot_id || userInfo.depot_id || '',
          from_location: selectedInward.from_depot_name || fromLocationName,
          fin_year: selectedInward.fin_year || (
            dayjs().month() >= 3
              ? `${dayjs().year()}-${dayjs().year() + 1}`
              : `${dayjs().year() - 1}-${dayjs().year()}`
          ),
        }));
       setTransferDetails(
          eligibleDetails.length > 0
            ? eligibleDetails
            : [{ srno: '', cylinder_no: '', cyl_id: '', prod_code: '', prod_id: '', status: '', owner: '', note: 'INSPDUE' }]
        );

        if (parsedTableDetails.length > 0 && eligibleDetails.length === 0) {
          setWarningMessage('Selected inward entry has no cylinders with Product ID 1 eligible for transfer.');
        }
      } else {
        setData((prev) => ({
          ...prev,
          inward_id: value,
          inward_no: '',
          entry_no: editData ? prev.entry_no : '',
          entry_date: editData?.entry_date
            ? dayjs(editData.entry_date).format("YYYY-MM-DD")
            : dayjs().format("YYYY-MM-DD"),
          to_plant_id: assigned_plant_id || '',
          to_location: assigned_plant_name || '',
          driver_id: '',
          from_customer_id: '',
          from_depot_id: userInfo.depot_id || '',
          from_location: fromLocationName,
          fin_year:
            dayjs().month() >= 3
              ? `${dayjs().year()}-${dayjs().year() + 1}`
              : `${dayjs().year() - 1}-${dayjs().year()}`,
        }));
        setTransferDetails([
          { srno: '', cylinder_no: '', cyl_id: '', prod_code: '', prod_id: '', status: '', owner: '', note: 'INSPDUE' },
        ]);
      }
    } else if (name === 'entry_date') {
      const selectedDate = dayjs(value);
      if (selectedDate.isValid()) {
        const month = selectedDate.month();
        const year = selectedDate.year();
        const financialYear = month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
        setData((prev) => ({ ...prev, entry_date: selectedDate.format("YYYY-MM-DD"), fin_year: financialYear }));
      } else {
        setData((prev) => ({ ...prev, entry_date: "" }));
        setWarningMessage("Invalid date selected.");
      }
    } else {
      setData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleChangeInput = async (e, index) => {
    const { name, value } = e.target;
    const updated = [...transferDetails];
    updated[index][name] = value;
    if (name === 'cylinder_no' && value) {
      try {
        const cylList = await cylinderMasterService.getCylinderList({ page: 0, size: 1, searchKey: value });
        if (Array.isArray(cylList) && cylList.length > 0) {
          updated[index]['cyl_id'] = cylList[0].cyl_id || '';
          updated[index]['status'] = cylList[0].status || cylList[0].state || '';
        } else {
          updated[index]['cyl_id'] = '';
          updated[index]['status'] = '';
        }
      } catch (err) {
        updated[index]['cyl_id'] = '';
        updated[index]['status'] = '';
      }
    }
    setTransferDetails(updated);
  };

  const handleAddRow = () => {
    setTransferDetails((prev) => [
      ...prev,
      { srno: '', cylinder_no: '', cyl_id: '', prod_code: '', prod_id: '', status: '', owner: '', note: 'INSPDUE' },
    ]);
  };

  const handleRemoveRow = (index) => {
    setTransferDetails((prev) => prev.filter((_, i) => i !== index));
  };

  const onSubmit = async (formData) => {
    if (!formData.from_depot_id && !userInfo.plant_id) {
      setWarningMessage('Cannot submit: No valid depot or plant assigned.');
      return;
    }
    if (!assigned_plant_id) {
      setWarningMessage('Cannot submit: No assigned plant.');
      return;
    }
    const inwardData = {
      ...formData,
      to_plant_id: assigned_plant_id,
      to_location: assigned_plant_name,
      modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      modified_by: editData ? userInfo.user_id : null,
      created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      created_by: editData ? editData.created_by : userInfo.user_id,
      table_details: JSON.stringify(transferDetails),
      changedUpdatedValue: 'edit',
      short_code,
      unit_id,
    };
    if (editData) {
      await transferToPlantService.editDeletetransfartoplant(inwardData);
    } else {
      await transferToPlantService.addtransfartoplant(inwardData);
    }
  };

  const handleSubmitWithConfirmation = withSaveConfirmation(onSubmit);
  const handleCancel = () => confirmNavigation(-1);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageSx}>

        {/* Breadcrumb */}
        <Box sx={breadcrumbSx}>
          <span>Dashboard</span> /{" "}
          <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Transfer to Plant Entry</span>
        </Box>

        {/* Page Header */}
        <Box sx={pageHeaderSx}>
          <Box sx={pageTitleSx}>
            <SwapHorizIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
            {editData ? "UPDATE" : "ADD"} TRANSFER TO PLANT ENTRY
          </Box>
          <Button onClick={() => navigate(-1)} sx={backBtnSx}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
          </Button>
        </Box>

        <form
          onSubmit={handleSubmit(() =>
            handleSubmitWithConfirmation(data, setSuccessMessage, setWarningMessage, navigate, editData)
          )}
        >

          {/* ── Transfer Entry Details Card ── */}
          <Box sx={formCardSx}>
            <Box sx={sectionHeaderSx}>
              <SwapHorizIcon sx={{ fontSize: 18, color: "#fff" }} />
              <Typography sx={sectionHeaderTitleSx}>TRANSFER TO PLANT DETAILS</Typography>
            </Box>

            <Box sx={formBodySx}>
              <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

                {/* ════ LEFT COLUMN — Inward No ════ */}
                <Grid
                  item xs={12} md={6}
                  sx={{
                    p: 2.5,
                    borderBottom: { xs: "2px dashed #CBD5E0", md: "none" },
                    borderRight: { md: "1px solid #E2E8F0" },
                  }}
                >
                  <Grid container spacing={1.5}>

                    {/* Last Entry No info */}
                    {!editData && inward?.[0]?.lastScheduleEntryNo && (
                      <Grid item xs={12}>
                        <Typography sx={{ fontSize: "11px", color: "#718096", mb: 0.5 }}>
                          Last Entry No: <strong>{inward[0].lastScheduleEntryNo}</strong>
                        </Typography>
                      </Grid>
                    )}

                    {/* Inward No */}
                    <Grid item xs={12} sm={7}>
                      <Typography sx={fieldLabelSx}>
                        Inward No <span style={{ color: "#E53E3E" }}>*</span>
                      </Typography>
                    <Autocomplete
  disablePortal
  fullWidth
  options={inward || []}
  getOptionLabel={(option) => option.entry_no || ''}
  value={inward.find((d) => d.inward_id === data.inward_id) || null}
  onChange={(event, newValue) => {
    handleChange({
      target: {
        name: 'inward_id',
        value: newValue ? newValue.inward_id : '',
      },
    });
  }}
  isOptionEqualToValue={(option, value) => option.inward_id === value.inward_id}
  noOptionsText="No inward entries available"
  renderOption={(props, option) => (
    <MenuItem {...props} sx={menuItemSx}>{option.entry_no}</MenuItem>
  )}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      fullWidth
      placeholder={
        editData && !editData.inward_id && editData.entry_no
          ? `Original: ${editData.entry_no}`
          : "Select Inward No"
      }
      sx={inputSx}
    />
  )}
/>
                    </Grid>

                  </Grid>
                </Grid>

                {/* ════ RIGHT COLUMN — Entry No + Entry Date ════ */}
                <Grid
                  item xs={12} md={6}
                  sx={{ p: 2.5, background: "#FAFBFC", pl: 3.5 }}
                >
                  <Grid container spacing={1.5}>

                    {/* Entry No */}
                    <Grid item xs={12} sm={5}>
                      <Typography sx={fieldLabelSx}>Entry No</Typography>
                      <TextField
                        size="small"
                        fullWidth
                        name="entry_no"
                        value={data.entry_no}
                        sx={readonlyInputSx}
                        InputProps={{ readOnly: true }}
                        placeholder="Auto-generated"
                      />
                    </Grid>

                    {/* Entry Date */}
                    <Grid item xs={12} sm={5}>
                      <Typography sx={fieldLabelSx}>
                        Entry Date <span style={{ color: "#E53E3E" }}>*</span>
                      </Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={data.entry_date ? dayjs(data.entry_date) : dayjs()}
                        onChange={(newValue) =>
                          handleChange({
                            target: {
                              name: "entry_date",
                              value: newValue ? newValue.format("YYYY-MM-DD") : "",
                            },
                          })
                        }
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                            required: true,
                            sx: inputSx,
                          },
                        }}
                      />
                    </Grid>

                  </Grid>
                </Grid>

              </Grid>
            </Box>
          </Box>

          {/* ── Cylinder Table Card ── */}
          <Box sx={formCardSx}>
            <TableContainer>
              <Table size="small" stickyHeader>
                <TableHead>
                  <tr>
                    {[
                      { label: "Sr No", align: "center" },
                      { label: "Cylinder No", align: "left" },
                      { label: "Owner", align: "left" },
                      { label: "Status", align: "left" },
                      // { label: "Note", align: "left" },
                      { label: "Action", align: "center" },
                    ].map(({ label, align }) => (
                      <th
                        key={label}
                        style={{
                          background: "#1C3A5E",
                          color: "#fff",
                          fontSize: "12px",
                          fontWeight: 600,
                          fontFamily: "'Inter', Arial, sans-serif",
                          padding: "10px 12px",
                          borderRight: "1px solid rgba(255,255,255,0.1)",
                          whiteSpace: "nowrap",
                          textAlign: align,
                        }}
                      >
                        {label}
                      </th>
                    ))}
                  </tr>
                </TableHead>
                <TableBody>
                  {transferDetails.map((row, index) => (
                    <tr
                      key={index}
                      style={{
                        background: index % 2 === 0 ? "#fff" : "#F8FAFC",
                        borderBottom: "1px solid #E2E8F0",
                      }}
                    >
                      {/* Sr No */}
                      <td style={{ padding: "6px 12px", fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "center" }}>
                        {index + 1}
                      </td>

                      {/* Cylinder No */}
                      <td style={{ padding: "4px 8px", minWidth: "140px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          name="cylinder_no"
                          value={row.cylinder_no}
                          onChange={(e) => handleChangeInput(e, index)}
                          inputProps={{ readOnly: true }} 
                          sx={{
                            ...inputSx,
                            "& .MuiOutlinedInput-root": {
                              ...inputSx["& .MuiOutlinedInput-root"],
                              height: "30px",
                              "& fieldset": { border: "none" },
                            },
                          }}
                        />
                      </td>

                      {/* Owner */}
                      <td style={{ padding: "4px 8px", minWidth: "120px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          name="owner"
                          value={row.owner || ''}
                          onChange={(e) => handleChangeInput(e, index)}
                          inputProps={{ readOnly: true }} 
                          sx={{
                            ...inputSx,
                            "& .MuiOutlinedInput-root": {
                              ...inputSx["& .MuiOutlinedInput-root"],
                              height: "30px",
                              "& fieldset": { border: "none" },
                            },
                          }}
                        />
                      </td>

                      {/* Status */}
                      <td style={{ padding: "4px 8px", minWidth: "100px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          name="status"
                          value={row.status}
                          onChange={(e) => handleChangeInput(e, index)}
                          inputProps={{ readOnly: true }} 
                          sx={{
                            ...inputSx,
                            "& .MuiOutlinedInput-root": {
                              ...inputSx["& .MuiOutlinedInput-root"],
                              height: "30px",
                              "& fieldset": { border: "none" },
                            },
                          }}
                        />
                      </td>

                      {/* Note */}
                      {/* <td style={{ padding: "4px 8px", minWidth: "110px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          name="note"
                          value={row.note}
                          onChange={(e) => handleChangeInput(e, index)}
                          inputProps={{ readOnly: true }} 
                          sx={{
                            ...inputSx,
                            "& .MuiOutlinedInput-root": {
                              ...inputSx["& .MuiOutlinedInput-root"],
                              height: "30px",
                              "& fieldset": { border: "none" },
                            },
                          }}
                        />
                      </td> */}

                      {/* Action */}
                      <td style={{ padding: "6px 12px", textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
                        <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
                          <IconButton
                            size="small"
                            onClick={handleAddRow}
                            sx={{ color: "#2063b6", "&:hover": { background: "#EBF4FF" }, borderRadius: "6px" }}
                          >
                            <AddIcon sx={{ fontSize: "16px", border: "1px solid #2063b6", borderRadius: "50%" }} />
                          </IconButton>
                          {index !== 0 && (
                            <IconButton
                              size="small"
                              onClick={() => handleRemoveRow(index)}
                              sx={{ color: "#E53E3E", "&:hover": { background: "#FFF5F5" }, borderRadius: "6px" }}
                            >
                              <DeleteForeverIcon sx={{ fontSize: "16px" }} />
                            </IconButton>
                          )}
                        </Box>
                      </td>
                    </tr>
                  ))}

                  {transferDetails.length === 0 && (
                    <tr>
                      <td colSpan={6} style={{ padding: "32px", textAlign: "center", color: "#A0AEC0", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" }}>
                        No cylinders added. Select an Inward No to auto-populate.
                      </td>
                    </tr>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Footer Buttons */}
            <Box sx={formFooterSx}>
              <Button sx={cancelBtnSx} onClick={handleCancel}>Cancel</Button>
              <Button type="submit" sx={saveBtnSx}>
                <SaveIcon sx={{ fontSize: 18 }} />
                {editData ? "Update" : "Save"}
              </Button>
            </Box>
          </Box>

        </form>

        {/* Snackbars */}
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => { if (reason !== 'clickaway') setSuccessMessage(''); }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
        <ReusableSnackbar
          open={!!warningMessage}
          onClose={(event, reason) => { if (reason !== 'clickaway') setWarningMessage(''); }}
          message={warningMessage}
          autoHideDuration={4000}
          vertical="top"
          horizontal="right"
          severity="warning"
        />
      </Box>
    </LocalizationProvider>
  );
};

export default Add_transfer_plant_entry;